var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('b-button',{attrs:{"size":"sm","variant":"primary","to":_vm.vsmRoute,"aria-label":"Back to VSM"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back to VSM\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }